<template>
  <v-container fluid grid-list-md ma-0 class="header-container">
    <v-layout row wrap justify-center>
      <v-flex xs12 pa-3 mb-2 class="header-content text-xs-center white--text headline font-weight-medium">
        Pipefish Contacts
      </v-flex>
      <v-flex xs12>
        <v-list two-line>
          <template v-for="(item, index) in items">
            <v-divider
              v-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>

            <v-list-tile
              v-else
              :key="index"
              avatar
            >
              <v-list-tile-avatar>
                <img :src="`https://ui-avatars.com/api/?bold=true&name=${item.user.GivenName}+${item.user.Surname}`">
              </v-list-tile-avatar>

              <v-list-tile-content>
                
                <v-list-tile-title> {{item.user.GivenName}} {{item.user.Surname}}</v-list-tile-title>
                <v-list-tile-sub-title> 
                  <a style="color:grey" :href="`mailto:${item.user.EmailAddress}`"> 
                    {{item.user.EmailAddress}} 
                  </a> 
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <span>
                <a style="color:black" :href="`tel:${item.user.Mobile}`">
                <v-icon v-if="item.user.Mobile" color="blueBackground">
                  mdi-phone
                </v-icon>
                {{ item.user.Mobile }}
                </a>
              </span>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    items: [],
    colors: [
      "99ccff",
      "ff66ff",
      "6699ff",
      "ff3399",
      "33cc33",
      "993333",
      "808080",
      "cc3399",
      "666699",
      "336600"
    ],
    activePipefishUsers: []
  }),
  computed: {
    ...mapState('admin', ['pipefishUsers'])
  },
  created() {
    var self = this
    if(this.pipefishUsers.length == 0) {
      this.$timesheetApi.getAllUsers().then(users => {
        self.setSortedPipefishUsers(users)
        self.mapUsers()
      })
    } else {
      this.mapUsers()
    }
  },
  methods: {
    ...mapActions('admin', ['setSortedPipefishUsers']),
    mapUsers() {
      // re-filter down pipefishUsers to only Active ones.
      
      this.activePipefishUsers = this.pipefishUsers.filter(user => {
        return user.IsActive == true;
      });
      this.activePipefishUsers.slice(0, this.activePipefishUsers.length - 1).forEach(user => {
        this.items.push({
          user: user, 
        })
        this.items.push({
          divider: true,
          inset: true
        })
      })
      this.items.push({
        user: this.activePipefishUsers[this.activePipefishUsers.length - 1]
      })
    }
  }

}
</script>

<style>
</style>
